import { createSelector } from 'reselect';
import { RootState } from 'redux/root.reducer';
import { EnquiryState } from './types';

const selectCache = (state: RootState) => state.enquiresCache;

export const selectLodgeEnquiry = createSelector(
  selectCache,
  (cache: any) => cache.data?.lodgeEnquiry
);

export const selectedEnquiry = createSelector(
  selectCache,
  (cache: any) => cache.data?.enquiry
);

export const selectEnquiries = createSelector(
  selectCache,
  (cache: any) => cache.data?.enquiries
);

export const selectEnquiryLoading = createSelector(
  selectCache,
  (cache: any) => cache.loading
);

export const selectEnquiryLoader = createSelector(
  selectCache,
  (cache: any) => cache.enquiryLoader
);

export const selectEnquirySearchFilters = createSelector(
  selectCache,
  (cache: any) => cache.data?.filters
);

export const loadMoreLoader = createSelector(
  selectCache,
  (cache: any) => cache.loader
);

export const updatingEnquiry = createSelector(
  selectCache,
  (cache: any) => cache.updatingEnquiry
);

export const enquiryError = createSelector(
  selectCache,
  (cache: any) => cache.error
);

export const selectForwardEnquiryExternalId = createSelector(
  selectCache,
  (cache: any) => cache.data?.forwardEnquiryExternalId
);

export const selectForwardEnquiryIsListView = createSelector(
  selectCache,
  (cache: any) => cache.data?.forwardIsListView
);

export const selectForwardEnquiryDateRangeText = createSelector(
  selectCache,
  (cache: any) => cache.data?.forwardDateRangeText
);

export const selectDownloadingCombinedPdf = createSelector(
  selectCache,
  (cache: EnquiryState) => cache.downloadingCombinedPdf
);

export const selectDownloadingCombinedZip = createSelector(
  selectCache,
  (cache: EnquiryState) => cache.downloadingCombinedZip
);

export const selectZipDownloadStatus = createSelector(
  selectCache,
  (cache: EnquiryState) => cache.zipDownloadStatus
);

export const selectPDFDownloadStatus = createSelector(
  selectCache,
  (cache: EnquiryState) => cache.pdfDownloadStatus
);

export const selectAttachmentPreviewUrl = createSelector(
  selectCache,
  (cache: EnquiryState) => cache.attachmentPreviewUrl
);

export const selectLoadingAttachmentPreviewUrl = createSelector(
  selectCache,
  (cache: EnquiryState) => cache.isLoadingAttachmentPreviewUrl
);

export const selectAttachmentDownloadUrl = createSelector(
  selectCache,
  (cache: EnquiryState) => cache.attachmentDownloadUrl
);

export const selectLoadingAttachmentDownloadUrl = createSelector(
  selectCache,
  (cache: EnquiryState) => cache.isLoadingAttachmentDownloadUrl
);

export const selectEnquiryConfirmationPDFDownloadUrl = createSelector(
  selectCache,
  (cache: EnquiryState) => cache.enquiryConfirmationPDFDownloadUrl
);

export const selectLoadingEnquiryConfirmationPDFDownloadUrl = createSelector(
  selectCache,
  (cache: EnquiryState) => cache.isLoadingEnquiryConfirmationPDFDownloadUrl
);

export const selectDownloadAdvancedOptions = createSelector(
  selectCache,
  (cache: EnquiryState) => cache.downloadAdvancedOptions
);

export const selectIsLoadingDownloadAdvancedOptions = createSelector(
  selectCache,
  (cache: EnquiryState) => cache.isLoadingDownloadAdvancedOptions
);
